import $ from "jquery";
import { debounce } from "../utils/functions";

const $window = $(window);
const $aboutEl = $(".about, .about-review");
const $kadenceElements = $(".about-review, .about-deadlines");

const about = (aboutEl) => {
  const data = {
    static: 8000,
    fade: 1500,
  };

  const $graduates = aboutEl.find(".graduate");

  setTimeout(() => normalizeGraduates($graduates), 500);
  $window.on(
    "resize:width",
    debounce(() => normalizeGraduates($graduates))
  );

  $graduates.length > 1 && cycle(0, $graduates, data);
};

const hackKadence = (element) => {
  const $column = element.closest(".wp-block-kadence-column");
  const $innerCol = $column.children(".kt-inside-inner-col");

  if ($column.length && $innerCol.length) {
    $column.css({
      "flex-grow": "1",
      "align-self": "unset",
    });
    $innerCol.css({
      "flex-grow": "1",
      display: "flex",
    });
  }
};

const normalizeGraduates = (graduates) => {
  let biggestHeight = -1;

  graduates.css("height", "");

  graduates.each(function () {
    const $thisEl = $(this).find(".graduate__container");

    let height;
    let marginHeight = $thisEl.outerHeight(true) - $thisEl.outerHeight();
    let imageHeight = $thisEl.find(".graduate__image").outerHeight(true);
    !imageHeight && (imageHeight = 25);
    let wrapperHeight = $thisEl.find(".graduate__wrapper").outerHeight(true);

    $thisEl.css("flex-direction") === "column"
      ? (height = marginHeight + imageHeight + wrapperHeight)
      : (height = marginHeight + Math.max(imageHeight, wrapperHeight));

    height > biggestHeight && (biggestHeight = height);
  });

  graduates.css("height", biggestHeight + "px");
};

const cycle = (index, graduates, data) => {
  const isFirstElement = index == 0;
  const isLastElement = index == graduates.length - 1;
  const $graduate = $(graduates.eq(index));

  if (isFirstElement) {
    $graduate.css("opacity") == 0
      ? cycleGraduate($graduate, data).then(() =>
          cycle((index += 1), graduates, data)
        )
      : fadeOutGraduate($graduate, data).then(() =>
          cycle((index += 1), graduates, data)
        );
  } else if (isLastElement) {
    cycleGraduate($graduate, data).then(() => cycle(0, graduates, data));
  } else {
    cycleGraduate($graduate, data).then(() =>
      cycle((index += 1), graduates, data)
    );
  }
};

const cycleGraduate = (graduate, data) =>
  new Promise((resolve) =>
    graduate.animate({ opacity: 1 }, data.fade, () =>
      fadeOutGraduate(graduate, data).then(() => resolve("done"))
    )
  );

const fadeOutGraduate = (graduate, data) =>
  new Promise((resolve) =>
    graduate
      .delay(data.static)
      .animate({ opacity: 0 }, data.fade, () => resolve("done"))
  );

if ($aboutEl.length > 0) {
  $aboutEl.each(function () {
    about($(this));
  });
}
if ($kadenceElements.length > 0) {
  $kadenceElements.each(function () {
    hackKadence($(this));
  });
}
